import React from 'react';
import PropTypes from 'prop-types';
import * as styles from './FootnotesSection.module.scss';

const FootnotesSection = ({ footnotes }) => {
  if (!footnotes || footnotes.length === 0) {
    return null;
  }

  return (
    <div className={styles.footnotesContainer}>
      <h2 className={styles.footnotesTitle}>
        Notes
      </h2>
      <ol className={styles.footnotesList}>
        {footnotes.map((footnote, index) => (
          <li
            className={styles.footnoteItem}
            id={`footnote-${index + 1}`}
            key={footnote.id}
          >
            <a
              aria-label={`Retour à la référence ${index + 1}`}
              className={styles.footnoteNumber}
              href={`#footnote-ref-${index + 1}`}
            >
              {index + 1}.
            </a>
            <span
              className={styles.footnoteContent}
              dangerouslySetInnerHTML={{ __html: footnote.content }}
            />
          </li>
        ))}
      </ol>
    </div>
  );
};

FootnotesSection.propTypes = {
  footnotes: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
  }))
};

export default FootnotesSection;